import { Endpoints, Http, HttpService } from "@/infra/api";
import { ChargerEntity } from "@/domain/entities";
import { Charger } from "@/domain/models";
import { ApiResponse, ApiQuery, ChargerDTO, ManualCommandForm } from "@/@types";

export interface ChargerRepository {
  getCharger: (id: string) => Promise<ApiResponse<Charger>>;
  getChargers: (query?: ApiQuery) => Promise<ApiResponse<Charger[]>>;
  createCharger: (params: ChargerDTO) => Promise<ApiResponse<ChargerEntity>>;
  deleteCharger: (id: string) => Promise<ApiResponse<ChargerEntity>>;
  updateCharger: (
    id: string,
    params: Partial<ChargerDTO>
  ) => Promise<ApiResponse<Charger>>;
  manualCommand: (params: ManualCommandForm) => Promise<ApiResponse<unknown>>;
}

export const ChargerService = (
  http: Http = HttpService()
): ChargerRepository => ({
  getCharger: async (id) => {
    const res = await http.get<ChargerEntity>(`${Endpoints.chargers}/${id}`);
    const data = new Charger(res.data);
    return { ...res, data };
  },
  getChargers: async (query?: ApiQuery) => {
    const res = await http.get<ChargerEntity[]>(Endpoints.chargers, query);
    const data = res.data?.length
      ? res.data.map((charger) => new Charger(charger))
      : [];
    return { ...res, data };
  },
  createCharger: async (params) => {
    return http.post<ChargerDTO, ChargerEntity>(Endpoints.chargers, params);
  },
  updateCharger: async (id: string, params: Partial<ChargerDTO>) => {
    const res = await http.put<Partial<ChargerDTO>, ChargerEntity>(
      `${Endpoints.chargers}/${id}`,
      params
    );
    const data = new Charger(res.data);
    return { ...res, data };
  },
  deleteCharger: async (id) => {
    return http.delete<ChargerEntity>(`${Endpoints.chargers}/${id}`);
  },
  manualCommand: (params) => {
    return http.post<ManualCommandForm, unknown>(
      Endpoints.manual_commands,
      params
    );
  },
});
